<template>
    <v-img v-if="imagePath" :src="imagePath" :alt="name" height="50" width="50" />
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            default: null,
        },
        imagePath: {
            type: String,
            default: null,
        },
    },
};
</script>
